// CANONICAL COPY (GH #7115). src/constants/obligations/obl-sdlc-regression-test.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-sdlc-regression-test',
  title: 'Regression test required for Critical and High SDLC risk PRs',
  description:
    'Any pull request that resolves a Critical or High severity SDLC risk must include at least one test file change (*.test.js or *.spec.js) in its diff. Verified automatically via the GitHub PR audit integration.',
  category: 'risk',
  scfIds: ['SCF-DEV-004', 'SCF-DEV-008', 'SCF-RSK-001'],
  cadence: { frequency: '1m', anchor: 'domain' },
  strategy: 'integration',
  integrationKey: 'github-pr-audit',
  fulfilmentCriteria: [
    {
      type: 'integration-check',
      integrationKey: 'github-pr-audit',
      check: 'criticalPrsHaveTestFiles',
      description:
        'PRs resolving Critical or High SDLC risks include at least one *.test.js or *.spec.js file in the changed files list',
    },
  ],
};
